(ns portfolio.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::active-section
 (fn [app-db _]
   (:active-section app-db)))

(rf/reg-sub
 ::lang
 (fn [app-db _]
   (:lang app-db)))
